module.exports = __webpack_public_path__ + "static/img/Jayden-Su_A.866ebe9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jayden-Su_A.jpg
// module id = 3r5Q
// module chunks = 0